// src/components/kuestion/KuestionMark.jsx
//
// The Kuestion brand mark — a guava with a question-mark cutout. Single source
// for the artwork so the suite card and the portal header can never drift.
//
// Colours are props rather than hardcoded because the mark sits on two very
// different grounds: a light coral card in /suite, and a navy tile in the
// portal header. Defaults suit the light case.
import React from 'react';

const KuestionMark = ({
  className,
  tile = false,             // draw the rounded brand tile behind the mark
  bodyFill = 'currentColor',
  leafFill = '#C0522E',
  glyphFill = '#fff',
}) => (
  <svg viewBox="0 0 64 64" className={className} role="img" aria-label="Kuestion">
    {tile && (
      <>
        <rect width="64" height="64" rx="16" fill="url(#kqMarkTile)" />
        <defs>
          <linearGradient id="kqMarkTile" x1="0" y1="0" x2="64" y2="64">
            <stop stopColor="#0B4F99" /><stop offset="1" stopColor="#083D77" />
          </linearGradient>
        </defs>
      </>
    )}

    {/* Inset the mark when it sits on the tile so it isn't flush to the corners */}
    <g transform={tile ? 'translate(32 32) scale(0.74) translate(-32 -32)' : undefined}>
      {/* Leaf */}
      <path d="M36 7.5c3.4-2.2 8-2.2 10.9-0.2-0.9 3.4-3.8 6.2-7.6 7-1.9 0.4-3.8 0.2-5.4-0.5 0.3-2.6 1.1-4.9 2.1-6.3z" fill={leafFill}/>
      {/* Guava body */}
      <path d="M32 11c1.5 0 2.6 1.1 3.1 2.6 0.8 2.6 2.4 4.7 4.6 6.7 6.9 6.2 11.8 11.9 11.8 20.4C51.5 51 42.8 55 32 55S12.5 51 12.5 40.7c0-8.5 4.9-14.2 11.8-20.4 2.2-2 3.8-4.1 4.6-6.7C29.4 12.1 30.5 11 32 11z" fill={bodyFill}/>
      {/* Question mark hook */}
      <path d="M32 23.5c-4.3 0-7.8 3.3-7.8 7.4 0 1.8 1.4 3.2 3.2 3.2s3.2-1.4 3.2-3.2c0-0.8 0.6-1.3 1.4-1.3s1.4 0.6 1.4 1.3c0 0.7-0.5 1.1-1.2 1.5-2.1 1.2-4.4 3-4.4 6.7v0.5c0 1.8 1.4 3.2 3.2 3.2s3.2-1.4 3.2-3.2v-0.5c0-0.5 0.2-0.8 1.1-1.3 2.2-1.2 4.5-3.3 4.5-6.9 0-4.1-3.5-7.4-7.8-7.4z" fill={glyphFill}/>
      {/* Dot */}
      <circle cx="32" cy="49.5" r="3.2" fill={glyphFill}/>
    </g>
  </svg>
);

export default KuestionMark;
